import { getColumnsByNames } from './all-top10-columns-config';

export const topDestinationDeniedColumns = getColumnsByNames([
    { name: 'rule' },
    { name: 'dst' },
    { name: 'dport' },
    { name: 'count', width: '41%' }
]);